import { QXMLObject } from "./QXMLObject";

export class QView extends QXMLObject {
  constructor() {
    super();
    this.fViewID = null;
    this.SetXMLElementName("view");
    this.fMissing = false;
  }

  InitView(viewID) {
    this.fViewID = viewID;
  }

  IsMissing() {
    return this.fMissing;
  }

  SetMissing(isMissing) {
    this.fMissing = isMissing;
  }

  GetViewID() {
    return this.fViewID;
  }

  Clone() {
    var aView = new QView();
    aView.InitView(this.GetViewID());
    var isMissing = this.IsMissing();
    aView.SetMissing(isMissing);

    return aView;
  }

  OutputSubElements(stream) {
    this.OutputSimpleElement("name", this.fViewID, stream);
  }

  LoadFromJSON(JSON) {
    this.fViewID = JSON["viewID"];
  }

  LoadChildElements(objTree) {
    this.fViewID = objTree.GetValueForChild("name", false);
  }

  OutputToJSON(json) {
    json.push({ viewID: this.fViewID });
  }
}
